import {FormHelperText, styled} from '@mui/material'
import {Texts} from 'appearance'
import {Controller} from 'react-hook-form'
import RichTextInput from '../RichTextInput'
import {useState} from 'react'
import Button from '../Button'
import {useI18n} from 'store/Store'
import {isBase64} from 'services/utils/misc'
import parse from 'html-react-parser'
import {Base64} from 'js-base64'

const FormRichTextInput = ({name, label, control, error, hidden}) => {
    const {i18n} = useI18n()
    const [editorActive, setEditorActive] = useState(false)

    const handleEditorActive = () => {
        setEditorActive(!editorActive)
    }

    const parseValue = (value) => {
        if (isBase64(value)) {
            return Base64.decode(value)
        }

        return value
    }

    return (
        !hidden && (
            <Container>
                <Label variant="caption" error={!!error}>
                    {label}
                </Label>
                <Controller
                    name={name}
                    control={control}
                    render={({field: {onChange, value}}) =>
                        editorActive ? (
                            <RichTextInput
                                value={parseValue(value)}
                                onChange={onChange}
                            />
                        ) : (
                            <ActiveEditorContainer>
                                <ButtonContainer>
                                    <Button
                                        onClick={handleEditorActive}
                                        variant="outlined"
                                        color="primary">
                                        {i18n.t('form.activateEditor', {
                                            itemName: label,
                                        })}
                                    </Button>
                                </ButtonContainer>
                                {value ? (
                                    <div>{parse(parseValue(value))}</div>
                                ) : (
                                    <Texts.Text>
                                        {i18n.t('form.noContent', {
                                            itemName: label,
                                        })}
                                    </Texts.Text>
                                )}
                            </ActiveEditorContainer>
                        )
                    }
                />
                {!!error && (
                    <FormHelperText error={!!error}>{error}</FormHelperText>
                )}
            </Container>
        )
    )
}

export default FormRichTextInput

const Container = styled('div')`
    display: flex;
    flex-direction: column;
    width: 100%;
`

const Label = styled(Texts.Text)(({theme, error}) => ({
    color: error ? theme.palette.error.main : 'rgba(0, 0, 0, 0.6)',
}))

const ButtonContainer = styled('div')`
    flex-shrink: 0;
    align-self: flex-end;
`

const ActiveEditorContainer = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
`
